<a [href]="appUrl" target="_blank">
  <img [src]="badgeUrl" *ngIf="badgeUrl"/>
</a>
